// Jedna, łatwo edytowalna lista produktów promowanych ("VoltValue Poleca").
// Ta lista decyduje o: (1) badge na karcie, (2) zawartości karuzeli „Polecane produkty".
// category = productType z frontendu: 'panel' | 'inwerter' | 'magazyn'.
// Aby dodać/edytować promowany produkt — zmień tylko tę tablicę.

export const RECOMMENDED_PRODUCTS = [
  { category: 'panel', id: 286 },
  { category: 'inwerter', id: 1957 },
  { category: 'magazyn', id: 105 },
  { category: 'panel', id: 1 },
]

export const getRecommendedIds = (productType) =>
  RECOMMENDED_PRODUCTS.filter((r) => r.category === productType).map((r) => r.id)

export const isRecommended = (productType, id) =>
  id != null && getRecommendedIds(productType).includes(Number(id))
